import { APP_INITIALIZER, FactoryProvider } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/** Loads angular-editor SVG symbols into the page once at startup (#undo refs need them in the DOM). */
export function provideAngularEditorIcons(): FactoryProvider {
  return {
    provide: APP_INITIALIZER,
    useFactory: (document: Document) => () => injectEditorIconSprite(document),
    deps: [DOCUMENT],
    multi: true,
  };
}

async function injectEditorIconSprite(document: Document): Promise<void> {
  const containerId = 'ae-editor-icon-sprite';
  if (document.getElementById(containerId)) {
    return;
  }

  const response = await fetch('/assets/ae-icons/icons.svg');
  if (!response.ok) {
    return;
  }

  const container = document.createElement('div');
  container.id = containerId;
  container.setAttribute('aria-hidden', 'true');
  container.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  container.innerHTML = await response.text();
  document.body.appendChild(container);
}
